import app from 'flarum/forum/app';
import addMaterialComplaintControl from './materialComplaintControl';
app.initializers.add('devconnect-content-complaints', () => {
  // Маршрут и компонент регистрируются через современный frontend extender;
  // инициализатор остаётся явной точкой присутствия расширения в клиентском приложении.
  addMaterialComplaintControl();
});